<template>
    <el-dialog append-to-body :visible.sync="visible" :close-on-click-modal="false" width="535px" :before-close="cancel">
        <div slot="title">
            <span class="title">上传图片</span>
            <span class="sub-title" v-if="aspectRatio">（尺寸不小于320px*180px，大小不超过2M，格式为jpg、png、jpeg）</span>
            <span class="sub-title" v-else>（尺寸不小于180px*180px，大小不超过2M，格式为jpg、png、jpeg）</span>
        </div>
        <div class="result-content">
            <i class="icon-warning"></i>
            {{errorInfo}}
        </div>
        <div class="footer">
            <btn :type="1" info="重新选择" @click="select"></btn>
        </div>
    </el-dialog>
</template>
<script>
import Btn from './Button';
    export default {
        components: {
            Btn
        },
        props: {
            errorInfo: {
                type: String,
                default: ''
            },
            visible: {
                type: Boolean,
                default: false
            },
            aspectRatio: {
                type: Number,
                default: 0
            }
        },
        methods: {
            cancel() {
                this.$emit('update:visible', false);
            },
            select() {
                this.$emit('select');
                this.$emit('update:visible', false);
            },
        }
    }
</script>
<style lang="less" scoped>
.result-content {
    text-align: center;
    font-size: 16px;
    margin-top: 30px;
}
.icon-warning {
    width: 18px;
    height: 18px;
    display: inline-block;
    vertical-align: text-top;
    background: url(./../assets/icon_failed.png) center center no-repeat;
    background-size: 100% 100%;
}
.title {
    font-size: 18px;
    color: #5C667E;
}
.sub-title {
    font-size: 12px;
    color: #5C667E;
}
.footer {
    text-align: center;
    margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ImageErrorDialog.vue